define('TescoMobile_Checkout/js/view/summary/monthly-total',['Magento_Checkout/js/view/summary/abstract-total', 'Magento_Checkout/js/model/quote'], function (Component, quote) {
  const config = window.checkoutConfig.tescomobile.monthly_payment;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/summary/monthly-total'
    },
    isDisplayed: function () {
      return this.isFullMode();
    },
    getPureValue: function () {
      return config.monthly_total;
    },
    getValue: function () {
      return this.getPureValue();
    }
  });
});

